const ClassicArmy = require('./ClassicArmy');
const Conquistadors = require('./Conquistadors');
const DefensiveArmy = require('./DefensiveArmy');
const Entrenchments = require('./Entrenchments');
const FightingBand = require('./FightingBand');
const Fortifications = require('./Fortifications');
const HeavyCavalry = require('./HeavyCavalry');
const Hussars = require('./Hussars');
const Legion = require('./Legion');
const MechanizedArmy = require('./MechanizedArmy');
const MedievalArmy = require('./MedievalArmy');
const MobileArtillery = require('./MobileArtillery');
const ModernArmy = require('./ModernArmy');
const NapoleonicArmy = require('./NapoleonicArmy');
const Phalanx = require('./Phalanx');
const PositionalArmy = require('./PositionalArmy');
const ShockTroops = require('./ShockTroops');

module.exports = {
    ClassicArmy,
    Conquistadors,
    DefensiveArmy,
    Entrenchments,
    FightingBand,
    Fortifications,
    HeavyCavalry,
    Hussars,
    Legion,
    MechanizedArmy,
    MedievalArmy,
    MobileArtillery,
    ModernArmy,
    NapoleonicArmy,
    Phalanx,
    PositionalArmy,
    ShockTroops,
}